import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * オンラインスピーキングSSO
 */
export namespace ApiTaLi060 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {
      query: {
        courseId: string // コースID
        previousMonthCount: number // 契約開始月の何ヶ月前から有効とするか
        overDayCount: number // 契約完了月の何日後まで有効とするか
      }
    }

    // API Response
    export interface Response {
      url: string // 遷移用URL
      ssoKey: string // 遷移用URL
    }
  }

  // API Path
  export const path: string = '/ta/onlineSpeaking'

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        url: '',
        ssoKey: '',
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
